module.exports = __webpack_public_path__ + "img/logo_name.600e89ce.svg";